import { useQuery } from '@tanstack/react-query'
import { TOURNAMENT_QUERY_KEYS } from '@/modules/tournament/constants'
import { TournamentService } from '@/modules/tournament/api/services'
import type { paths } from '@/schema'

type TournamentResponse =
	paths['/api/admin/tournaments/{id}']['get']['responses']['200']['content']['application/json']

const useQueryGetTournamentById = (id: string) => {
	return useQuery<TournamentResponse>({
		queryKey: TOURNAMENT_QUERY_KEYS.TOURNAMENTS.DETAIL(id),
		queryFn: () => TournamentService.getTournamentById(id),
		enabled: !!id,
	})
}

export default useQueryGetTournamentById
